import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotaFiscal } from 'src/app/models/nota-fiscal';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotaFiscalService } from 'src/app/services/nota-fiscal.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarNotaFiscalPedidoModalComponent } from './cadastrar-nota-fiscal-pedido-modal/cadastrar-nota-fiscal-pedido-modal.component';
import { GlobalService } from 'src/app/services/global.service';

declare const $: any;

@Component({
  selector: 'app-nota-fiscal-pedido-modal',
  templateUrl: './nota-fiscal-pedido-modal.component.html',
  styleUrls: ['./nota-fiscal-pedido-modal.component.scss']
})
export class NotaFiscalPedidoModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  notasFiltradas: NotaFiscal[] = [];
  carregando = true;
  idCupom: any;
  administrador: boolean = false;
  podeAdicionarNota: boolean = false;
  filtraOcorrencia: boolean = false;

  @ViewChild('paginatorAnexo', { static: false }) paginator: MatPaginator;

  constructor(
    private utilitarioService: UtilitarioService,
    private notaFiscalService: NotaFiscalService,
    public dialogRef: MatDialogRef<NotaFiscalPedidoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService
  ) {
    this.idCupom = data.idCupom;
    this.podeAdicionarNota = data.podeAdicionarNota;
    this.filtraOcorrencia = data.filtraOcorrencia;
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    this.buscarNotas();
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarNotas() {
    this.carregandoService.mostra('buscarModelosDownload');
    this.carregando = true;

    this.notaFiscalService.buscarNotasDoPedido(this.idCupom, this.filtraOcorrencia).subscribe(dados => {
      this.notasFiltradas = dados;

      this.carregando = false;
      this.carregandoService.esconde('buscarModelosDownload');
    }, (erro) => {
      this.carregandoService.esconde('buscarModelosDownload');
      this.notificacaoService.erro(erro);
    });
  }

  imprimirNota(nota) {
    this.carregandoService.mostra('imprimirNota');

    this.notaFiscalService.imprimirNotaPorNNota(nota).subscribe(resp => {
      // this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
      this.utilitarioService.openBlob(resp);

      this.carregandoService.esconde('imprimirNota');
    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('imprimirNota');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }

  excluirNota(idNota) {
    swal({
      title: 'Atenção!!',
      html: '<p>Deseja realmente excluir esta Nota Fiscal?</p><p>Esta operação <b>NÃO</b> poderá ser desfeita.</p>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirNota');

        this.notaFiscalService.excluir(idNota).subscribe(resp => {
          this.carregandoService.esconde('excluirNota');
          this.notificacaoService.sucesso('Nota Fiscal excluída com sucesso!!');
          this.buscarNotas();
        }, (erro) => {
          this.carregandoService.esconde('excluirNota');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  adicionarNota() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarNotaFiscalPedidoModalComponent, {
      width: largura > 830 ? '900px' : (($('body').width()).toString() + 'px'),
      data: {
        idCupom: this.idCupom
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarNotas();
      }
    });
  }
}
